// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM = "Diskuze";
export const REVIEW_SECTION_OFFER = "Nab\u00eddka";
export const REVIEW_SECTION_OVERVIEW = "P\u0159ehled";
export const STROLLER_QUESTIONS_AND_ANSWERS = "Ot\u00e1zky a odpov\u011bdi";
export const STROLLER_REVIEWS = "Hodnocen\u00ed";
